import { MonitoringSource } from "@services/devices/types";
import { deviceSourceMap, sourceValues } from "../filters/mappers/devices";

export const MonitoringSourceValueMapping = {
  [sourceValues.direct]: "Direct",
  [sourceValues.DMCA]: "DMCA",
  [sourceValues.controller]: "Controller",
  [sourceValues.thirdParty]: "Aggregator",
};

export const getMonitoringSourceValue = (
  value?: MonitoringSource[],
  label: boolean = false
) => {
  if (value === undefined || (!Array.isArray(value) && value === "")) return [];
  if (!Array.isArray(value)) {
    value = deviceSourceMap[value] || [value];
  }

  const temp = [];

  value.sort((a, b) => {
    if (a === MonitoringSource.CommProxy) return -1;
    if (b === MonitoringSource.CommProxy) return 1;
    if (a === MonitoringSource.AVISPLMonitoringAgent) return 1;
    if (b === MonitoringSource.AVISPLMonitoringAgent) return -1;
    if (a && b && a < b) return -1;
    if (a && b && a > b) return 1;
    return 0;
  });
  for (var i = 0; i < value.length; i++) {
    temp.push(
      value[i] == sourceValues.DMCA && label
        ? "DMCA"
        : MonitoringSourceValueMapping[value[i]]
    );
  }
  return temp;
};

export const getMonitoringSourceLabel = (
  value?: MonitoringSource[],
  raw?: boolean
) => {
  return getMonitoringSourceValue(value, true);
};
